/**
 * api/_shared.js — utilities used across domain api modules.
 * Internal — not re-exported through the public barrel.
 */
import { supabase } from "@/lib/supabaseClient";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;

/** Bearer header for direct fetch() calls to the FastAPI backend. */
export async function authHeaders(extra = {}) {
  const { data: { session } } = await supabase.auth.getSession();
  return session?.access_token ? { ...extra, Authorization: `Bearer ${session.access_token}` } : extra;
}

/** Authenticated FastAPI POST helper. */
export async function backendCall(path, body) {
  const { data: { session } } = await supabase.auth.getSession();
  const res = await fetch(`${BACKEND}${path}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: session?.access_token ? `Bearer ${session.access_token}` : "",
    },
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    const t = await res.text().catch(() => "");
    let msg = t;
    try {
      const j = JSON.parse(t);
      msg = j?.detail || j?.message || t;
    } catch (_e) { /* keep raw text */ }
    return { error: { message: msg || `HTTP ${res.status}` } };
  }
  return { data: await res.json() };
}

/** Get a client's storage slug → bucket name `lbs-{slug}`. */
export async function getClientSlug(clientId) {
  const { data } = await supabase
    .from("lbs_clients")
    .select("slug")
    .eq("id", clientId)
    .maybeSingle();
  return data?.slug || null;
}
